import React, { Fragment } from 'react'
import PagesHeading from '../pages-heding/PagesHeading'
import FeedBack from '../feedback-page/FeedBack'
const FeedBackPage = (props) => {
  return (
    <Fragment>
        <PagesHeading page_title={props.page_title}></PagesHeading>
        <FeedBack></FeedBack>
    </Fragment>
  )
}

export default FeedBackPage